var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#626362;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.2,57.9h-49V10.6c0-3.1-2.7-5.6-5.9-5.6H62.6c-3.3,0-5.8,2.6-5.8,5.6v47.3h-49c-3.3,0-5.8,2.6-5.8,5.6v53 c0,3.2,2.7,5.6,5.8,5.6h49v47.3c0,3.1,2.7,5.6,5.8,5.6h54.8c3.3,0,5.9-2.6,5.9-5.6v-47.3h49c3.2,0,5.8-2.6,5.8-5.6v-53 C178.1,60.5,175.4,57.9,172.2,57.9 M166.3,111h-54.8v53H68.4v-53H13.6V69.2h54.8V16.2h43.1v53.1h54.8V111z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.c3a57ef3d2eecfc06a732d00885d1869.svg";
export { ForwardRef as ReactComponent };